const ChipResult = ({ result, color, bgColor, border }) => {
  return (
    <div
      style={{
        border: border ? `1px solid ${border}` : 'none',
        color,
        borderRadius: '4px',
        padding: '2px 8px',
        backgroundColor: bgColor
      }}
      className='text-nowrap'
    >
      {result}
    </div>
  )
}

export default ChipResult
